import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, FormControl, FormControlLabel, Checkbox, TextField, Collapse, useTheme, Autocomplete, Chip } from "@mui/material";
import Question from "../../components/Question";
import ContinueButton from "../../components/ContinueButton";
import { setSex as updateSex } from "../../redux/userSlice";
import { MinorUserContext } from "../../context/UserNameProvider";
import { continueButtonSx, textAreaSx, inputLabelSx, checkboxSx } from "../../lib/uiformatting";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

const birthControlOptions = {
    condom: "Condom",
    pill: "Birth control pill",
    iud: "IUD",
    implant: "Implant",
    abstinence: "Abstinence",
    plan_b: "Plan B",
    other: "Other"
};

export default function Maternity(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { returning = false } = location.state || {};
    const theme = useTheme();

    const { isMinor, firstName } = useContext(MinorUserContext);

    const user = useSelector((state) => state.user);

    const [maternity, setMaternity] = useState([]);
    const [selectedBirthControls, setSelectedBirthControls] = useState([]);
    const [otherBirthControl, setOtherBirthControl] = useState("");
    const [error, setError] = useState(false);
    const [followUpCare, setFollowUpCare] = useState([]);
    const questionsForDoctor = useSelector((state) => state.user.questionsForDoctor);

    useEffect(() => {
        const followUpArray = Array.isArray(user.followUpCare)
            ? user.followUpCare
            : typeof user.followUpCare === "string"
                ? [user.followUpCare]
                : [];
        setFollowUpCare(followUpArray);
    }, [user.followUpCare]);

    // TBD - accutane
    // const showBirthControl =
    //     user.concern === "Acne" &&
    //     (user.sex?.sexAtBirth === "Female" ||
    //         user.sex?.sexAtBirth === "Prefer not to say") &&
    //     user.treatmentContinuation?.interestedInAccutane === "Y" &&
    //     user.address?.state === "CT";
    const showBirthControl = false;

    const options = {
        "Currently pregnant": "Currently pregnant",
        "Currently breastfeeding": "Currently breastfeeding",
        "Currently trying to get pregnant": "Currently trying to get pregnant",
        ...(showBirthControl && {
            "Currently on birth control": "Currently on birth control"
        })
    };

    useEffect(() => {
        const storedMaternity = Array.isArray(user.sex?.maternity)
            ? user.sex.maternity
            : typeof user.sex?.maternity === "string"
                ? [user.sex.maternity]
                : [];
        setMaternity(storedMaternity);

        if (showBirthControl) {
            if (user.sex?.birthControlMethods) {
                setSelectedBirthControls(user.sex.birthControlMethods);
            }
            if (user.sex?.otherBirthControl) {
                setOtherBirthControl(user.sex.otherBirthControl);
            }
        }
    }, [
        user.sex?.maternity,
        user.sex?.birthControlMethods,
        user.sex?.otherBirthControl,
        showBirthControl
    ]);

    const handleChange = (e) => {
        const { name, checked } = e.target;

        setMaternity((prevmaternity) => {
            let newmaternity = [...prevmaternity];
            if (checked) {
                if (name === "Currently pregnant" || name === "Currently trying to get pregnant") {
                    newmaternity = newmaternity.filter(
                        (item) =>
                            item !== "Currently on birth control" &&
                            item !== "Currently pregnant" &&
                            item !== "Currently trying to get pregnant"
                    );
                    if (showBirthControl) {
                        setSelectedBirthControls([]);
                        setOtherBirthControl("");
                        setError(false);
                    }
                    newmaternity.push(name);
                }
                else if (name === "Currently on birth control" && showBirthControl) {
                    newmaternity = newmaternity.filter((item) => item === "Currently breastfeeding");
                    newmaternity.push(name);
                }
                else if (name === "Currently breastfeeding") {
                    newmaternity.push(name);
                }

                if (newmaternity.length > 2) {
                    newmaternity.splice(0, 1);
                }
            } else {
                newmaternity = newmaternity.filter((item) => item !== name);
                if (name === "Currently on birth control" && showBirthControl) {
                    setSelectedBirthControls([]);
                    setOtherBirthControl("");
                    setError(false);
                }
            }
            return newmaternity;
        });
    };

    const handleNext = () => {
        if (
            showBirthControl &&
            maternity.includes("Currently on birth control") &&
            selectedBirthControls.length === 0
        ) {
            setError(true);
            return;
        }

        dispatch(
            updateSex({
                ...user.sex,
                maternity,
                birthControlMethods: showBirthControl ? selectedBirthControls : [],
                otherBirthControl:
                    showBirthControl && selectedBirthControls.includes("Other")
                        ? otherBirthControl
                        : ""
            })
        );

        if (returning) {
            setPageAndDeferNavigate(dispatch, '/recent-photo', navigate);
        } else {
            // accutane
            if (
                user.concern === "Acne" &&
                (user.sex?.sexAtBirth === "Female" ||
                    user.sex?.sexAtBirth === "Prefer not to say") &&
                user.treatmentContinuation?.interestedInAccutane === "Y" &&
                (user.address?.state === "CT" || user.address?.state === "MA")
            ) {
                setPageAndDeferNavigate(dispatch, '/last-period-date', navigate);
            } else {
                setPageAndDeferNavigate(dispatch, '/allergies', navigate);
            }
        }
    };

    const handleBack = () => {
        if (returning) {
            if (user.isIsotretinoin && user.pickedMedication === "yes" && user.onPrescribedMedication === "yes") {
                if (user.mentalHealthTrigger) {
                    setPageAndDeferNavigate(dispatch, '/phq9-questionnaire', () =>
                        navigate('/phq9-questionnaire', { state: { returning: true } })
                    );
                } else {
                    setPageAndDeferNavigate(dispatch, '/side-effects-checklist', () =>
                        navigate('/side-effects-checklist', { state: { returning: true } })
                    );
                }
            } else if (questionsForDoctor) {
                setPageAndDeferNavigate(dispatch, '/questions-for-doctor', () =>
                    navigate('/questions-for-doctor', { state: { returning: true } })
                );
            }
            else if (followUpCare.includes("I have questions for the provider") ||
                followUpCare.includes("I have another reason not listed above")
            ) {
                setPageAndDeferNavigate(dispatch, '/follow-up-care', () =>
                    navigate('/follow-up-care', { state: { returning: true } })
                );
            } else {
                setPageAndDeferNavigate(dispatch, '/picked-medication', () =>
                    navigate('/picked-medication', { state: { returning: true } })
                );
            }
        }
        else if (user.sex.contraceptive || user.sex?.otherContraceptive) {
            setPageAndDeferNavigate(dispatch, '/contraceptive', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/sex-at-birth', navigate);
        }
    };

    return (
        <Question
            onBack={handleBack}
            returning={returning}
            title={
                returning
                    ? "For medication purposes, can you confirm your pregnancy status?"
                    : `For medication purposes, ${isMinor ? `is ${firstName}` : "are you"
                    } pregnant, trying to get pregnant, breastfeeding${showBirthControl ? ", or on birth control?" : "?"
                    }`
            }
            subtitle="You can select multiple responses"
            input={
                <Box
                    sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            width: "100%",
                            maxWidth: "400px",
                            [theme.breakpoints.up("sm")]: {
                                justifyContent: "center",
                                maxWidth: "300px"
                            }
                        }}
                    >
                        <FormControl sx={{ display: "flex", flexDirection: "column", width: "100%", maxWidth: "400px", mb: "2rem", gap: "1rem" }}>
                            {Object.keys(options).map((key) => (
                                <Box key={key}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={maternity.includes(key)}
                                                onChange={handleChange}
                                                name={key}
                                            />
                                        }
                                        label={options[key]}
                                        sx={{ ...checkboxSx }}
                                    />

                                    {showBirthControl && (
                                        <Collapse
                                            in={key === "Currently on birth control" && maternity.includes("Currently on birth control")}
                                            mountOnEnter
                                            unmountOnExit
                                        >
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: { xs: "flex-start", sm: "center" },
                                                    mt: "1rem"
                                                }}
                                            >
                                                <FormControl
                                                    sx={{
                                                        width: { xs: "100%", sm: "600px" },
                                                        ml: { xs: 0, sm: 0 }
                                                    }}
                                                >
                                                    <Autocomplete
                                                        multiple
                                                        value={selectedBirthControls}
                                                        options={Object.values(birthControlOptions)}
                                                        onChange={(e, newValue) => {
                                                            setSelectedBirthControls(newValue);
                                                            if (!newValue.includes("Other")) {
                                                                setOtherBirthControl("");
                                                            }
                                                            setError(newValue.length === 0);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Birth control methods"
                                                                variant="outlined"
                                                                color="secondary"
                                                                sx={{
                                                                    ...textAreaSx, mt: 2,
                                                                    "& .MuiInputLabel-root": {
                                                                        backgroundColor: theme.palette.background.paper,
                                                                        padding: "0 32px",
                                                                        transition: "all 0.2s ease-in-out",
                                                                    },
                                                                }}
                                                                error={error}
                                                                helperText={
                                                                    error ? "Please select at least one method." : ""
                                                                }
                                                                InputLabelProps={{
                                                                    sx: {
                                                                        ...inputLabelSx,
                                                                        pl: 5,
                                                                        "& .MuiInputLabel-shrink": {
                                                                            backgroundColor: theme.palette.background.paper,
                                                                        },
                                                                    }
                                                                }}
                                                                required
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                        renderTags={(values, getTagProps) =>
                                                            values.map((option, index) => (
                                                                <Chip
                                                                    variant="outlined"
                                                                    sx={{ fontSize: "1rem" }}
                                                                    label={option}
                                                                    {...getTagProps({ index })}
                                                                />
                                                            ))
                                                        }
                                                    />

                                                    {selectedBirthControls.includes("Other") && (
                                                        <TextField
                                                            label="Other birth control method"
                                                            variant="outlined"
                                                            color="secondary"
                                                            sx={{
                                                                ...textAreaSx, mt: 3, width: "100%",
                                                                "& .MuiInputLabel-root": {
                                                                    backgroundColor: theme.palette.background.paper,
                                                                    padding: "0 32px",
                                                                    transition: "all 0.2s ease-in-out",
                                                                },
                                                            }}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    ...inputLabelSx,
                                                                    pl: 5,
                                                                    "& .MuiInputLabel-shrink": {
                                                                        backgroundColor: theme.palette.background.paper,
                                                                    },
                                                                }
                                                            }}
                                                            value={otherBirthControl}
                                                            onChange={(e) => setOtherBirthControl(e.target.value)}
                                                            required
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                </FormControl>
                                            </Box>
                                        </Collapse>
                                    )}
                                </Box>
                            ))}
                        </FormControl>
                    </Box>
                </Box>
            }
            footer={
                <Box
                    sx={{ ...continueButtonSx }}
                >
                    <ContinueButton
                        onClick={handleNext}
                        title={maternity.length > 0 ? "Continue" : "None of the above"}
                        selected={
                            maternity.length > 0 &&
                            (!maternity.includes("Currently on birth control") || selectedBirthControls.length > 0)
                        }
                        disabled={
                            maternity.includes("Currently on birth control") &&
                            selectedBirthControls.length === 0
                        }
                    />
                </Box>
            }
        />
    );
};
